import PropTypes from 'prop-types'

import RadioButton from 'components/form/RadioButton'
import TextInput from 'components/form/TextInput'
import PasswordInput from 'components/form/PasswordInput'
import {
  setIsLimitedSite,
  setLimitedSiteId,
  setLimitedSitePassword,
} from 'features/channel/add/channelAddSlice'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'components/table/Table'
import ErrorText from 'components/form/ErrorText'

const Account = ({
  hasAccessAccountError,
  accessAccountIdError,
  accessAccountPasswordError,
  isEditable,
}) => {
  const dispatch = useDispatch()
  const { hasAccessAccount, accessAccountId, accessAccountPassword } =
    useSelector(state => state.channel.channelAdd)
  const onSetLimitedSiteId = v => dispatch(setLimitedSiteId(v))
  const onSetLimitedSitePassword = v => dispatch(setLimitedSitePassword(v))

  return (
    <Table.Row
      className="tr_account"
      error={
        hasAccessAccountError ||
        accessAccountIdError ||
        accessAccountPasswordError
      }>
      <th scope="row">
        <div className="inner_tbl">검수계정</div>
      </th>
      <td>
        <div className="inner_tbl">
          <div className="item_tit">
            <strong className="tit_detail">
              등록하신 웹사이트가 제한적인 운영 사이트 이거나 성인 사이트입니까?
            </strong>
          </div>
          <div className="item_filter">
            <RadioButton.Group
              className="filter_radio"
              focusOnError
              error={hasAccessAccountError}>
              <RadioButton
                checkValue={hasAccessAccount}
                value={true}
                disabled={!isEditable}
                onValueChange={() => dispatch(setIsLimitedSite(true))}
                label="예"
              />
              <RadioButton
                checkValue={hasAccessAccount}
                value={false}
                disabled={!isEditable}
                onValueChange={() => dispatch(setIsLimitedSite(false))}
                label="아니오"
              />
            </RadioButton.Group>
            <ErrorText error={hasAccessAccountError} />
          </div>
          {hasAccessAccount && (
            <div className="group_item">
              <TextInput
                focusOnError
                value={accessAccountId}
                onValueChange={onSetLimitedSiteId}
                error={accessAccountIdError}
                disabled={!isEditable}
                placeholder="아이디"
              />
              <PasswordInput
                focusOnError
                value={accessAccountPassword}
                onValueChange={onSetLimitedSitePassword}
                error={accessAccountPasswordError}
                disabled={!isEditable}
                placeholder="비밀번호"
              />
              <ErrorText
                tag="p"
                error={accessAccountIdError || accessAccountPasswordError}
              />
              <p className="txt_info">
                회원 전용 사이트일 경우 개인정보가 포함되지 않은 테스트용
                아이디와 패스워드를 전달 바랍니다.
              </p>
            </div>
          )}
        </div>
      </td>
    </Table.Row>
  )
}

export default Account

Account.propTypes = {
  hasAccessAccountError: PropTypes.string,
  accessAccountIdError: PropTypes.string,
  accessAccountPasswordError: PropTypes.string,
  isEditable: PropTypes.bool,
}
